import axios from "axios";
import React from "react";
import { useNavigate } from "react-router-dom";
import { Confirm } from 'react-st-modal';

const ItemUpDel = ({ myitem ,setMyItems,myitems}) => {
  
  const { _id, productName, price, quantity, img } = myitem;
  const navigate = useNavigate();
  const handleItemDelete = async (id) => {
    const url = "https://glacial-dawn-34678.herokuapp.com/delete";
    const proceed = await Confirm('Are you Sure you want to Delete?', 
    'Warning');
  
    if (proceed) {
      const result = await axios.delete(url, { data: { id: id } });
      console.log(result.data);
      const remainder = myitems.filter((item) => item._id !== id);
      setMyItems(remainder);
    }
  };
  
  return (
    <li className="flex flex-col py-6 sm:flex-row sm:justify-between mx-auto">
      <div className="flex w-full space-x-2 sm:space-x-4">
        <img
          className="flex-shrink-0 object-cover w-20 h-20 dark:border-transparent rounded outline-none sm:w-32 sm:h-32 dark:bg-coolGray-500"
          src={img}
          alt={_id}
        />
        <div className="flex flex-col justify-between w-full pb-4">
          <div className="flex justify-between w-full pb-2 space-x-2">
            <div className="space-y-1">
              <h3 className="text-lg font-semibold leading-snug sm:pr-8">
                {productName}
              </h3>
              <p className="text-sm dark:text-coolGray-400">
                Quantity: {quantity}
              </p>
            </div>
            <div className="text-right">
              <p className="text-lg font-semibold">${price}</p>
            </div>
          </div>
          <div className="flex text-sm divide-x">
            <button
              onClick={() => handleItemDelete(_id)}
              type="button"
              className="flex items-center px-2 py-1 pl-0 space-x-1"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
                className="w-4 h-4 fill-current"
              >
                <path d="M96,472a23.82,23.82,0,0,0,23.579,24H392.421A23.82,23.82,0,0,0,416,472V152H96Zm32-288H384V464H128Z"></path>
                <rect width="32" height="200" x="168" y="216"></rect>
                <rect width="32" height="200" x="240" y="216"></rect>
                <rect width="32" height="200" x="312" y="216"></rect>
                <path d="M328,88V40c0-13.458-9.488-24-21.6-24H205.6C193.488,16,184,26.542,184,40V88H64v32H448V88ZM216,48h80V88H216Z"></path>
              </svg>
              <span>Remove</span>
            </button>
            <button
            onClick={()=>navigate(`/inventory/${_id}`)}
              type="button"
              className="flex items-center px-2 py-1 space-x-1"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-4 h-4 fill-current"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path d="M11 17a1 1 0 001.447.894l4-2A1 1 0 0017 15V9.236a1 1 0 00-1.447-.894l-4 2a1 1 0 00-.553.894V17zM15.211 6.276a1 1 0 000-1.788l-4.764-2.382a1 1 0 00-.894 0L4.789 4.488a1 1 0 000 1.788l4.764 2.382a1 1 0 00.894 0l4.764-2.382zM4.447 8.342A1 1 0 003 9.236V15a1 1 0 00.553.894l4 2A1 1 0 009 17v-5.764a1 1 0 00-.553-.894l-4-2z" />
              </svg>
              <span>Manage Item</span>
            </button>
          </div>
        </div>
      </div>
    </li>
  );
};

export default ItemUpDel;
